module.exports = __webpack_public_path__ + "static/media/internal-chat-new-message.b8b38dca.wav";